const ExemptionReason = {
  LOW_VALUE: 'low_value',
  CORPORATE: 'corporate',
  TRUSTED_BENEFICIARY: 'trusted_beneficiary',
  RISK_ANALYSIS: 'risk_analysis',
  DELEGATED_AUTHENTICATION: 'delegated_authentication',
};

module.exports = ExemptionReason;
